import { useQuery } from 'react-query';
import axios from 'axios';
import { axiosDummyInstance, axiosInstance, axiosScraper } from '@utils/axios/axiosInstance';
import { METHOD_TYPE } from '@configs/api';

export interface QueryHookParam {
  key: string[];
  url: string;
  params: any;
  method: METHOD_TYPE;
  enabled: boolean;
  staleTime?;
}

/**
 *
 * @param url
 * @param params
 * @returns
 */
export const postAxios = async (url, params) => {
  if (!params || !url) {
    return null;
  }
  const { data } = await axiosInstance.post(url, params);
  return data;
};

/**
 *
 * @param {*} url
 * @param {*} params
 * @returns
 */
export const getDummyAxios = async (url, params = null) => {
  if (!url) {
    return null;
  }
  if (!params) {
    const { data } = await axiosDummyInstance.get(url);
    return data;
  } else {
    const { data } = await axiosDummyInstance.get(url, { params: params });
    return data;
  }
};

export const getRealAxios = async (url, params = null) => {
  if (!url) {
    return null;
  }
  if (!params) {
    const { data } = await axiosInstance.get(url);
    return data;
  } else {
    const { data } = await axiosInstance.get(url, { params: params });
    return data;
  }
};

/**
 * @description 스프링 api로 요청하는 useQueryHook
 * @param param
 * @returns
 */
export function useQueryHook(param: QueryHookParam) {
  const { key, url, params, method, enabled, staleTime = 10000 } = param;

  const getAxiosFunction = (_method: METHOD_TYPE, url: string, params: any) => {
    switch (_method) {
      case 'POST':
        return postAxios(url, params);
      case 'GET':
        return getRealAxios(url, params);
      default:
        break;
    }
  };

  return useQuery(key, () => getAxiosFunction(method, url, params), {
    // throwOnError: true,
    enabled,
    refetchOnWindowFocus: false,
    staleTime,
  });
}

export function useQueryDummyHook(param: QueryHookParam) {
  const { key, url, params, method, enabled, staleTime = 10000 } = param;

  const getAxiosFunction = (_method: METHOD_TYPE, url: string, params: any) => {
    switch (_method) {
      case 'POST':
        return postAxios(url, params);
      case 'GET':
        return getDummyAxios(url, params);
      default:
        break;
    }
  };

  return useQuery(key, () => getAxiosFunction(method, url, params), {
    // throwOnError: true,
    enabled,
    refetchOnWindowFocus: false,
    staleTime,
  });
}
